import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { environment } from '../../environments/environment';
import { notificationArray, NotificationResponse } from '../models/notification.model';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  showDot: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  constructor(private http: HttpClient) {}

  getNotificationListing(query: string): Observable<NotificationResponse> {
    return this.http
      .get<{
        data: NotificationResponse;
      }>(`${environment.base_url}notification?${query}`)
      .pipe(map(res => res.data));
  }
  addNotification(payload: Notification): Observable<Notification> {
    return this.http
      .post<{
        data: Notification;
      }>(`${environment.base_url}notification`, payload)
      .pipe(map(res => res.data));
  }

  getReceivedNotificationList(query: string): Observable<notificationArray> {
    return this.http
      .get<{
        data: notificationArray;
      }>(`${environment.base_url}receivedNotifications?${query}`)
      .pipe(map(res => res.data));
  }
}
